/**
 * Single source of truth for allowed file extensions.
 * Add new formats here — all validators and UI messages will pick them up automatically.
 */
export const ALLOWED_FILE_EXTENSIONS = [
  'SAV', 'RAW', 'RAWX', 'PY', 'SEQ',
  'IEC', 'DYR', 'OUT', 'OUTX', 'IDV',
  'CON', 'MON', 'SUB', 'DFAX', 'ACC',
  'DFX', 'SLD', 'DAT', 'MDL',
] as const;

/** Lowercase versions for Electron dialog filters */
export const ALLOWED_FILE_EXTENSIONS_LOWER = ALLOWED_FILE_EXTENSIONS.map(ext => ext.toLowerCase());

/** Display string for error messages (e.g., ".sav, .raw, .rawx, .py, .seq") */
export const ALLOWED_EXTENSIONS_DISPLAY = ALLOWED_FILE_EXTENSIONS.map(ext => `.${ext.toLowerCase()}`).join(', ');